export default __webpack_public_path__ + "static/media/currency.8ec33ff2.svg";